import { useState } from 'react';
import { X, Save } from 'lucide-react';
import { api } from '@/lib/api';

export default function UserEditModal({ user: target, onClose, onSaved }) {
  const [name, setName] = useState(target.name || '');
  const [email, setEmail] = useState(target.email || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const payload = { name, email };
      if (password) payload.password = password;
      await api(`/users/${target.id}`, { method: 'PATCH', body: JSON.stringify(payload) });
      onSaved?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="drawer-overlay" onClick={onClose} data-testid="user-edit-modal">
      <form className="preview-box user-edit-box" onSubmit={submit} onClick={(e) => e.stopPropagation()}>
        <div className="preview-head">
          <div>
            <span className="eyebrow">EDIT PROFILE</span>
            <div><strong>{target.name}</strong> <small className="muted">· {target.role === 'corporate_hr' ? 'Corporate HR' : 'Vessel HR'}</small></div>
          </div>
          <button type="button" className="icon-btn" data-testid="user-edit-close" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="user-edit-body">
          <label className="field"><span>Full name</span>
            <input data-testid="edit-user-name" value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label className="field"><span>Email address</span>
            <input data-testid="edit-user-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label className="field"><span>New password <small className="muted">(leave blank to keep current)</small></span>
            <input data-testid="edit-user-password" type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 8 characters" />
          </label>
          {error && <div data-testid="edit-user-error" className="error">{error}</div>}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="secondary-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="primary-btn" data-testid="edit-user-save" disabled={busy}>
              <Save size={14} /> {busy ? 'Saving…' : 'Save changes'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
